import { Collection } from 'modules/core/lib/mobx-rest'

import Field from 'modules/custom_resources/store/models/customResources/Field'

class Fields extends Collection<Field> {
  get cacheKey(): string {
    return 'customResourcesFields'
  }

  model() {
    return Field
  }
}

export default Fields
